import $api from '@/api'
import { getToken, setToken, removeToken, setAccountCode } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    currentDrugCode: localStorage.getItem('currentDrugCode') || ''
  }
}

const state = getDefaultState()

const mutations = {
  SET_DRUG_CODE: (state, code) => {
    state.currentDrugCode = code
    localStorage.setItem('currentDrugCode', code)
  }
}

const actions = {

  setDrugCode({ dispatch, commit }, code) {
    commit('SET_DRUG_CODE', code)
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
